/* WP-10 step-up context (§14.7): context object, hook and cancellation error
 * live apart from the provider component so step-up.tsx stays fast-refresh
 * clean. */
import { createContext, useContext } from 'react';

export type StepUpContextValue = {
  /** Runs fn; on PORTAL_STEP_UP_REQUIRED opens the sheet and retries once. */
  withStepUp: <T>(fn: () => Promise<T>) => Promise<T>;
  /** Proactively ensure step-up (e.g. before opening a confirm dialog). */
  requireStepUp: () => Promise<void>;
};

export const StepUpContext = createContext<StepUpContextValue>({
  withStepUp: async (fn) => fn(),
  requireStepUp: async () => {},
});

export function useStepUp(): StepUpContextValue {
  return useContext(StepUpContext);
}

export class StepUpCancelledError extends Error {
  constructor() {
    super('PORTAL_STEP_UP_CANCELLED');
    this.name = 'StepUpCancelledError';
  }
}

export function isStepUpCancelled(err: unknown): boolean {
  return err instanceof StepUpCancelledError;
}
